import type {components} from "./generated";
import type {AuthorizedFetch} from "./client";

export type ProductWorkspaceProjection = components["schemas"]["ProductWorkspaceProjection"];

export async function readProductWorkspace(
  fetcher: AuthorizedFetch,
  productKey: string,
  signal?: AbortSignal
): Promise<ProductWorkspaceProjection> {
  const response = await fetcher(`/api/v1/product-workspaces/${encodeURIComponent(productKey)}`, {
    signal,
    headers: {Accept: "application/json"}
  });
  if (!response.ok) {
    const problem = await response.json().catch(() => null) as {message?: string} | null;
    throw new Error(problem?.message ?? `Product Workspace read failed: ${response.status}`);
  }
  return await response.json() as ProductWorkspaceProjection;
}
